import paths, { rootPaths } from './paths';

export const productsRoutes = {
  label: 'Products',
  children: [
    {
      name: 'Products',
      active: true,
      icon: 'cube',
      children: [
        {
          name: 'Listing',
          to: rootPaths.productRoot,
          exact: true,
          active: true,
        },
        {
          name: 'Manage Products',
          to: paths.manageProduct,
          active: true,
        },
      ],
    },
  ],
};

export const purchaseOrderRoutes = {
  label: 'Purchase Orders (PO)',
  children: [
    {
      name: 'Purchase Orders (PO)',
      active: true,
      icon: 'box',
      children: [
        {
          name: 'PO List',
          to: rootPaths.purchaseOrderRoot,
          exact: true,
          active: true,
        },
        {
          name: 'Vendor List',
          to: paths.vendor,
          exact: true,
          active: true,
        },
        {
          name: 'GRN',
          to: paths.grn,
          exact: true,
          active: true,
        },
        {
          name: 'Putaway',
          to: paths.putAway,
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const ordersRoutes = {
  label: 'Orders',
  children: [
    {
      name: 'Orders',
      active: true,
      icon: 'shopping-cart',
      children: [
        {
          name: 'Order List',
          to: rootPaths.orderRoot,
          exact: true,
          active: true,
        },
        {
          name: 'Shipments',
          to: paths.shipment,
          exact: true,
          active: true,
        },
        {
          name: 'Picklist',
          to: paths.picklist,
          exact: true,
          active: true,
        },
        {
          name: 'Manifests',
          to: paths.manifests,
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const inventoryRoutes = {
  label: 'Inventory',
  children: [
    {
      name: 'Inventory',
      active: true,
      icon: 'boxes',
      children: [
        {
          name: 'Inventory',
          to: rootPaths.inventoryRoot,
          exact: true,
          active: true,
        },
        {
          name: 'Inventory History',
          to: paths.inventoryHistory,
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const returnRoutes = {
  label: 'Return',
  children: [
    {
      name: 'Return',
      active: true,
      icon: 'redo-alt',
      children: [
        {
          name: 'Return Manifest',
          to: paths.returnManifests,
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export const bulkActionRoutes = {
  label: 'File Upload',
  children: [
    {
      name: 'File Upload',
      icon: 'file-upload',
      to: rootPaths.bulkActionRoot,
      active: true,
    },
  ],
};

export const adminRoutes = {
  label: 'Administration',
  adminOnly: true,
  children: [
    {
      name: 'Administration',
      active: true,
      icon: 'user-shield',
      children: [
        {
          name: 'User',
          to: paths.user,
          exact: true,
          active: true,
        },
        {
          name: 'Shelf',
          to: paths.shelf,
          exact: true,
          active: true,
        },
        {
          name: 'Warehouse',
          to: paths.warehouse,
          exact: true,
          active: true,
        },
        {
          name: 'Sequence',
          to: paths.sequence,
          exact: true,
          active: true,
        },
        {
          name: 'Shipping Provider',
          to: paths.shippingProvider,
          exact: true,
          active: true,
        },
      ],
    },
  ],
};

export default [
  productsRoutes,
  purchaseOrderRoutes,
  ordersRoutes,
  inventoryRoutes,
  returnRoutes,
  bulkActionRoutes,
  adminRoutes,
];
